import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class SessionRedirectGuard implements CanActivate {

  constructor(private router: Router) {}

  canActivate(): boolean {
    const mockSessionId = 685018995

    this.router.navigate(['/sessions', mockSessionId]);
    return false;
  }
}